export default "__VITE_ASSET__HwY0PBJa__"